export const JdShopAuthURL = 'https://fw.jd.com/main/detail/FW_GOODS-1918009?p=fw&t=searchhistory';
